import { PPI } from "@/box/constants.js"

function getSvgForGeom(box) {
  const svgWidth = box.getDocumentWidth();
  const svgHeight = box.getDocumentHeight();

  let svg = `
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="${svgWidth}"
          height="${svgHeight}"
          viewBox="0 0 ${svgWidth} ${svgHeight}"
          stroke="blue"
          stroke-width="0.01" >
          `;

  box.panels.forEach((panel) => {
    svg += `<path fill="none" data-panelName="${panel.name} ${panel.row}Row" data-panelWidth="${panel.width}" data-panelHeight="${panel.height}" d="${panel.path}"/>`;
  })

  svg += "</svg>";

  return svg;
}

function get2DEditorSvg(box, printSide = "outside") {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  const largerDocumentDimension = documentWidth > documentHeight ? documentWidth : documentHeight
  const strokeWidth = largerDocumentDimension / 3000

  let svg = `
    <svg
      width="${documentWidth}"
      height="${documentHeight}"
      viewBox="0 0 ${documentWidth} ${documentHeight}"
      stroke-width="${strokeWidth}"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1">
  `

  svg += getOutline(box, printSide)

  svg += getCutlines(box, printSide)

  svg += `</svg>`;
  return svg
}

function createPathDefinitionForOutlineWithBleed(box, isNormalized = false) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const D = box.depthInPx
  const FH = box.flapHeightInPx
  const FG = box.flapGapInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const glueFlap = panels.find(panel => panel.name === "glueFlap")
  const side4TopFlap = panels.find(panel => panel.name === "side4TopFlap")

  const d = `
      M ${adjustedX(0)} ${adjustedY(FH)}
      h ${adjustedX(glueFlap.width + FG)}
      v ${adjustedY(-FH)}
      H ${adjustedX((side4TopFlap.left + side4TopFlap.width) + B)}
      v ${adjustedY(FH)}
      h ${adjustedX(FG)}
      v ${adjustedY(D + 2*B)}
      h ${adjustedX(-FG)}
      v ${adjustedY(FH)}
      H ${adjustedX(glueFlap.left + glueFlap.width - B + FG)}
      v ${adjustedY(-FH)}
      h ${adjustedX(-glueFlap.width - B)}
      v ${adjustedY(-glueFlap.height)}
      Z
  `
  return d
}

function getOutlineWithBleed(box, isNormalized = false, printSide) {
  const transformElement = printSide === 'inside' ? `transform: scaleX(-1) translateX(-1px);` : ''
  const path = `
    <path
      style="${transformElement}"
      stroke="green"
      fill="#000000"
      d="${createPathDefinitionForOutlineWithBleed(box, isNormalized)}" />
  `
  return path
}

function createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const D = box.depthInPx
  const FH = box.flapHeightInPx
  const FG = box.flapGapInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const glueFlap = panels.find(panel => panel.name === "glueFlap")
  const side2BottomFlap = panels.find(panel => panel.name === "side2BottomFlap")
  const side3TopFlap = panels.find(panel => panel.name === "side3TopFlap")
  const side4TopFlap = panels.find(panel => panel.name === "side4TopFlap")

  const d = `
    M ${adjustedX(glueFlap.left + glueFlap.width - B + FG)} ${adjustedY(FH)}
    v ${adjustedY(-FH)}
    H ${adjustedX((side4TopFlap.left + side4TopFlap.width) + B)}
    v ${adjustedY(FH)}
    h ${adjustedX(FG)}
    v ${adjustedY(D + 2*B)}
    h ${adjustedX(-FG)}
    v ${adjustedY(FH)}
    H ${adjustedX(side4TopFlap.left + side4TopFlap.width - B)}
    v ${adjustedY(-FH)}
    H ${adjustedX(side3TopFlap.left + side3TopFlap.width + B)}
    v ${adjustedY(FH)}
    H ${adjustedX(side2BottomFlap.left + side2BottomFlap.width - B)}
    v ${adjustedY(-FH)}
    h ${adjustedX(-side2BottomFlap.width + B)}
    v ${adjustedY(FH)}
    H ${adjustedX(glueFlap.left + glueFlap.width - B + FG)}
    v ${adjustedY(-FH)}
    Z
  `
  return d
}

function createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized) {
  const documentWidth = box.canvasWidth
  const documentHeight = box.canvasHeight

  // Normalizes x between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedX(x) {
    return isNormalized ? x / documentWidth: x;
  }

  // Normalizes y between 0 and 1 or return raw x value depending on isNormalized
  // This way if svg viewbox is not set to 1 1 the values represent percentages
  function adjustedY(y) {
    return isNormalized ? y / documentHeight : y;
  }

  const B = box.bleedInPx
  const D = box.depthInPx
  const FH = box.flapHeightInPx
  const FG = box.flapGapInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const glueFlap = panels.find(panel => panel.name === "glueFlap")
  const side2BottomFlap = panels.find(panel => panel.name === "side2BottomFlap")
  const side3TopFlap = panels.find(panel => panel.name === "side3TopFlap")
  const side4TopFlap = panels.find(panel => panel.name === "side4TopFlap")

  const d = `
    M ${adjustedX(glueFlap.left + glueFlap.width - B + FG)} ${adjustedY(FH)}
    v ${adjustedY(-FH)}
    H ${adjustedX((side4TopFlap.left + side4TopFlap.width) + B)}
    v ${adjustedY(FH)}
    h ${adjustedX(FG)}
    v ${adjustedY(D + 2*B)}
    h ${adjustedX(-FG)}
    v ${adjustedY(FH)}
    H ${adjustedX(side4TopFlap.left + side4TopFlap.width - B)}
    v ${adjustedY(-FH)}
    H ${adjustedX(side3TopFlap.left + side3TopFlap.width + B)}
    v ${adjustedY(FH)}
    H ${adjustedX(side2BottomFlap.left + side2BottomFlap.width - B)}
    v ${adjustedY(-FH)}
    h ${adjustedX(-side2BottomFlap.width + B)}
    v ${adjustedY(FH)}
    H ${adjustedX(glueFlap.left + glueFlap.width - B + FG)}
    v ${adjustedY(-FH)}
    Z
  `
  return d
}

function getOutlineWithoutNonPrintPanels(box, isNormalized = false, printSide = 'outside') {
  const def = printSide === 'outside'
    ? createPathDefinitionForOutlineWithoutNonPrintPanels(box, isNormalized)
    : createPathDefinitionForOutlineWithoutNonPrintPanelsForInsidePrint(box, isNormalized)

  const transformStyle = printSide === 'outside' ? '' : `transform: scaleX(-1); transform-origin: center;`

  const path = `
    <path
      style="${transformStyle}"
      stroke="green"
      fill="#000000"
      d="${def}" />
  `
  return path
}

function createOutlinePathDefinition(box) {
  const B = box.bleedInPx
  const D = box.depthInPx
  const FH = box.flapHeightInPx
  const FG = box.flapGapInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const glueFlap = panels.find(panel => panel.name === "glueFlap")
  const side1TopFlap = panels.find(panel => panel.name === "side1TopFlap")
  const side2TopFlap = panels.find(panel => panel.name === "side2TopFlap")

  const d = `
    M ${B} ${B + FH}
    h ${glueFlap.width + FG}
    v ${-FH}
    h ${side1TopFlap.width}
    v ${FH}
    h ${2*FG}
    v ${-FH}
    h ${side2TopFlap.width}
    v ${FH}
    h ${2*FG}
    v ${-FH}
    h ${side1TopFlap.width}
    v ${FH}
    h ${2*FG}
    v ${-FH}
    h ${side2TopFlap.width}
    v ${FH}
    h ${FG}
    v ${D}
    h ${-FG}
    v ${FH}
    h ${-side2TopFlap.width}
    v ${-FH}
    h ${-2*FG}
    v ${FH}
    h ${-side1TopFlap.width}
    v ${-FH}
    h ${-2*FG}
    v ${FH}
    h ${-side2TopFlap.width}
    v ${-FH}
    h ${-2*FG}
    v ${FH}
    h ${-side1TopFlap.width}
    v ${-FH}
    h ${-glueFlap.width}
    Z
  `

  return d
}

function getOutline(box, printSide = 'outside') {
  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''

  const path = `
    <path
      style="${transformElement}"
      stroke="blue"
      fill="none"
      d="${createOutlinePathDefinition(box)}" />
  `

  return path
}

function createCutlinesPathDefinition(box) {
  const FG = box.flapGapInPx

  const panels = box.panels.map(panel => ({
    ...panel,
    left: panel.left * PPI,
    top: panel.top * PPI,
    width: panel.width * PPI,
    height: panel.height * PPI
  }))

  const side1 = panels.find(panel => panel.name === "side1")
  const side2 = panels.find(panel => panel.name === "side2")
  const side3 = panels.find(panel => panel.name === "side3")
  const side4 = panels.find(panel => panel.name === "side4")

  // Red part of foldlines
  const redArea = `
    M ${side1.left} ${side1.top}
    h ${side1.width - FG}
    M ${side2.left + FG} ${side2.top}
    h ${side2.width - 2*FG}
    M ${side3.left + FG} ${side3.top}
    h ${side3.width - 2*FG}
    M ${side4.left + FG} ${side4.top}
    h ${side4.width - 2*FG}
    M ${side1.left + FG} ${side1.top + side1.height}
    h ${side1.width - 2*FG}
    M ${side2.left + FG} ${side2.top + side1.height}
    h ${side2.width - 2*FG}
    M ${side3.left + FG} ${side3.top + side1.height}
    h ${side3.width - 2*FG}
    M ${side4.left + FG} ${side4.top + side1.height}
    h ${side4.width - 2*FG}
    M ${side1.left} ${side1.top}
    v ${side1.height}
    M ${side1.left + side1.width} ${side1.top}
    v ${side1.height}
    M ${side2.left + side2.width} ${side2.top}
    v ${side2.height}
    M ${side3.left + side3.width} ${side3.top}
    v ${side3.height}
  `

  // White part of foldlines
  const whiteFoldLines = `
    M ${side1.left} ${side1.top}
    h ${side1.width - FG}
    M ${side2.left + FG} ${side2.top}
    h ${side2.width - 2*FG}
    M ${side3.left + FG} ${side3.top}
    h ${side3.width - 2*FG}
    M ${side4.left + FG} ${side4.top}
    h ${side4.width - 2*FG}
    M ${side1.left + FG} ${side1.top + side1.height}
    h ${side1.width - 2*FG}
    M ${side2.left + FG} ${side2.top + side1.height}
    h ${side2.width - 2*FG}
    M ${side3.left + FG} ${side3.top + side1.height}
    h ${side3.width - 2*FG}
    M ${side4.left + FG} ${side4.top + side1.height}
    h ${side4.width - 2*FG}
    M ${side1.left} ${side1.top}
    v ${side1.height}
    M ${side1.left + side1.width} ${side1.top}
    v ${side1.height}
    M ${side2.left + side2.width} ${side2.top}
    v ${side2.height}
    M ${side3.left + side3.width} ${side3.top}
    v ${side3.height}
  `

  return {
    redArea,
    whiteFoldLines
  }
}

function getCutlines(box, printSide = 'outside') {
  const {
    redArea,
    whiteFoldLines
  } = createCutlinesPathDefinition(box)
  const transformElement = printSide === 'inside'
    ? `transform: scaleX(-1); transform-origin: center;`
    : ''

  // Red part of foldlines
  let path = `
    <path
      style="${transformElement}"
      stroke="red"
      fill="none"
      stroke-dasharray="10 10"
      d="${redArea}" />
  `

  // White part of foldlines
  path += `
    <path
      style="${transformElement}"
      stroke="white"
      fill="none"
      stroke-dasharray="10 10"
      stroke-dashoffset="10"
      d="${whiteFoldLines}" />
  `

  return path
}

export {
  getSvgForGeom,
  get2DEditorSvg,
  getOutlineWithBleed,
  getOutlineWithoutNonPrintPanels,
  getOutline,
  getCutlines,
}
